export const SERVICE_DESCRIPTION_SECTION_TITLE =
  "Elevated Service, Thoughtfully Executed";

export const LEGACY_SERVICE_DESCRIPTION_SECTION_TITLE = "What this gives you";
